export const Goods = {
    LOADING_GOODS_LIST: "LOADING_GOODS_LIST",
    GET_GOODS_LIST: "GET_GOODS_LIST",
  };